<template>
  <v-app>
    <navigation></navigation>
    <v-main>
      <router-view/>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        
        bottom
        right
        color="orange"
        @click="toTop"
      >
        <v-icon large>mdi mdi-arrow-up-circle</v-icon>
      </v-btn>
    </v-main>
    <v-overlay :opacity="opacity" :value="loading"> <loadingAnim/></v-overlay>
  </v-app>
</template>

<script>
import loadingAnim from '@/components/load.vue';

import { mapGetters } from "vuex";
import navigation from '@/components/navigation.vue'
export default {
  name: 'App',

  data: () => ({
    fab: false,
    opacity: 0.8,
  }),
  components:{
    navigation,
    loadingAnim,

  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  computed:{
    ...mapGetters(['loading']),
  },
};
</script>
